export type {Language, TranslationKey, TranslationObject, EnumTranslationKeys, MultiLanguageString, Translate} from '@poinz/locale';
import { FALLBACK_LANGUAGE, LANGUAGES_TRANSLATED, LANGUAGE as LANGUAGE_LIB } from '@poinz/locale';

export const defaultLanguage = FALLBACK_LANGUAGE;
export const Languages = LANGUAGES_TRANSLATED;
export const LANGUAGE = LANGUAGE_LIB;
